import React, { Component } from 'react';
import { Button, Card, Form, message, Table } from 'antd';

import { queryClueList, queryImportClue, querySaveClue } from '@api/crm/crm';
import ModalThread from './ModalThread';
import ModalImport from './ModalImport';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pageNo: 1,
      total: 0,
      modalVisible: false,
      importModalVisible: false,
    };
  }

  componentDidMount() {
    this.getData();
  }

  getData = pageNo => {
    const no = this.state.pageNo;
    const current = pageNo || no;
    this.setState({
      pageNo: current,
    });
    queryClueList({
      start: current,
    }).then(res => {
      this.setState({
        data: res.data,
        total: res.totalSize,
      });
    });
  };

  handleModalVisible = (flag, record) => {
    this.record = record || {};
    this.setState({
      modalVisible: !!flag,
    });
  };

  handleImportModalVisible = (flag, record) => {
    this.record = record || {};
    this.setState({
      importModalVisible: !!flag,
    });
  };

  handleSubmit = params => {
    querySaveClue(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getData();
        this.handleModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  handleImport = params => {
    queryImportClue(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getData();
        this.handleImportModalVisible(false);
      } else {
        message.error(res.message);
      }
    });
  };

  columns = () => {
    return [
      {
        title: '编号',
        dataIndex: 'uuid',
        render: (text, record, index) => {
          return <span>{index + 1}</span>;
        },
      },
      {
        title: '名称',
        dataIndex: 'name',
      },
      {
        title: '联系人',
        dataIndex: 'contactName',
      },
      {
        title: '联系人电话',
        dataIndex: 'contactTel',
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return (
            <span>
              <a onClick={() => this.handleModalVisible(true, record)}>编辑</a>
            </span>
          );
        },
      },
    ];
  };

  render() {
    const { data, modalVisible, importModalVisible, pageNo, total } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: pageNo,
      onChange: current => {
        this.getData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListOperator">
            <Button type="primary" onClick={() => this.handleModalVisible(true)}>
              添加
            </Button>
            <Button type="primary" onClick={() => this.handleImportModalVisible(true)}>
              导入线索
            </Button>
          </div>
        </div>
        <Table
          rowKey="uuid"
          rowSelection={{}}
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
        {modalVisible ? (
          <ModalThread
            handleModalVisible={this.handleModalVisible}
            handleSubmit={this.handleSubmit}
            detail={this.record}
          />
        ) : null}
        {importModalVisible ? (
          <ModalImport cancel={this.handleImportModalVisible} handleSubmit={this.handleImport} />
        ) : null}
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/crm/thread/Index.js